import { FunctionComponent, ReactNode } from "react";

import { TabInfo } from "./models";
import { Nil } from "cy-util";

import { FadeInLoadContentTransition } from "../Transitions/FadeInLoadContentTransition";
import { cn } from "../../utils/cn";

export interface TabContentProps {
  className?: string;
  selectedTab?: TabInfo | Nil;
  children: (tab?: TabInfo | Nil) => ReactNode;
}

/**
 *
 */
export const TabContent: FunctionComponent<TabContentProps> = ({
  className,
  selectedTab,
  children,
}) => {
  return (
    <FadeInLoadContentTransition className={cn(className)}>
      {children(selectedTab)}
    </FadeInLoadContentTransition>
  );
};

export default TabContent;
